/**
 * User Persona Service
 */

import { httpClient } from '../http-client';
import { ErrorCodes } from '@/types/api-response.types';
import type { UserPersona } from './types';

const API_BASE_URL = '/api/v1';

export const UserPersonaService = {
  /**
   * Get user persona
   */
  async getUserPersona(): Promise<UserPersona | null> {
    try {
      const url = `${API_BASE_URL}/user-persona`;
      const response = await httpClient.get<UserPersona>(url);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof Error && error.name === 'ApiError' && 'code' in error && (error as { code: string }).code === ErrorCodes.RESOURCE_NOT_FOUND) {
        return null;
      }
      if (error instanceof Error && 'response' in error && (error as { response?: { status?: number } }).response?.status === 404) {
        return null;
      }
      console.error('Error fetching user persona:', error);
      throw error;
    }
  },

  /**
   * Create user persona
   */
  async createUserPersona(persona: UserPersona): Promise<UserPersona> {
    try {
      const url = `${API_BASE_URL}/user-persona`;
      const response = await httpClient.post<UserPersona>(url, persona);
      return response.data;
    } catch (error) {
      console.error('Error creating user persona:', error);
      throw error;
    }
  },

  /**
   * Update user persona
   */
  async updateUserPersona(id: string, persona: UserPersona): Promise<UserPersona> {
    try {
      const url = `${API_BASE_URL}/user-persona/${id}`;
      const response = await httpClient.put<UserPersona>(url, persona);
      return response.data;
    } catch (error) {
      console.error('Error updating user persona:', error);
      throw error;
    }
  },

  /**
   * Delete user persona
   */
  async deleteUserPersona(): Promise<void> {
    try {
      const url = `${API_BASE_URL}/user-persona`;
      await httpClient.delete<void>(url);
    } catch (error) {
      console.error('Error deleting user persona:', error);
      throw error;
    }
  },
};
